import { render, staticRenderFns } from "./TipoContaField.vue?vue&type=template&id=08c8b024&scoped=true&"
import script from "./TipoContaField.vue?vue&type=script&lang=js&"
export * from "./TipoContaField.vue?vue&type=script&lang=js&"
import style0 from "./TipoContaField.vue?vue&type=style&index=0&id=08c8b024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8b024",
  null
  
)

export default component.exports